import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/credentials';
import ModalAnnouncement from '../Modals/ModalAnnouncement';
import { Title } from './styled';
import { highlightWords } from '../utils';

interface TitleContentProps {
  title: string;
  titleUrl: string;
  highlightWord?: string;
}

function TitleContent({ title, titleUrl, highlightWord }: TitleContentProps) {
  const [showModal, setShowModal] = useState<boolean>(false);
  const textRef = useRef<HTMLElement | null>(null);

  const { isLoggedIn } = useSelector(selectors);

  const handleOpenLink = (e) => {
    e.preventDefault();

    const isExternalLink = titleUrl.indexOf('://') > -1;

    if (isExternalLink) {
      window.open(titleUrl, '_blank');
    } else if (isLoggedIn) {
      setShowModal(true);
    } else {
      window.location.href = '/register';
    }
  };

  useEffect(() => {
    if (!textRef?.current) {
      return;
    }

    if (highlightWord) {
      highlightWords(highlightWord, textRef.current, 'mark');
    }
  }, []);

  return (
    <div>
      <Title
        // @ts-expect-error
        ref={textRef}
        href={titleUrl}
        onClick={handleOpenLink}
      >
        {title}
      </Title>
      <ModalAnnouncement
        url={titleUrl}
        visible={showModal}
        destroyOnClose
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
}

export default TitleContent;
